import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_YOUTUBE_SHORT_VIDEOS,
  GET_YOUTUBE_SHORT_VIDEO_DETAILS,
  CREATE_YOUTUBE_SHORT_VIDEO,
  UPDATE_YOUTUBE_SHORT_VIDEO,
  DELETE_YOUTUBE_SHORT_VIDEO,
} from "./actionTypes"
import {
  getYoutubeShortVideosFail,
  getYoutubeShortVideosSuccess,
  getYoutubeShortVideoDetailsSuccess,
  getYoutubeShortVideoDetailsFail,
  createYoutubeShortVideoFail,
  createYoutubeShortVideoSuccess,
  updateYoutubeShortVideoSuccess,
  updateYoutubeShortVideoFail,
  deleteYoutubeShortVideoSuccess,
  deleteYoutubeShortVideoFail,
} from "./actions"

import { get, post, ApiPut, del } from "helpers/api_helper"
import { Notification } from "../../components/Common/Notification"

// YoutubeShortVideo - This line cannot be edited or removed
function getYoutubeShortVideosAPi({ page, sort, limit, searchText }) {
  return get(
    `/short/admin/all/?page=${page ? page : 1}&limit=${
      limit ? limit : 10
    }&search=${searchText}`
  )
}

const getYoutubeShortVideoDetailsAPi = youtubeShortVideoId => {
  return get(`/short/admin/${youtubeShortVideoId}`)
}

const createYoutubeShortVideoApi = ({ youtubeShortVideo, onCloseClick }) => {
  return post("/short/admin/new", youtubeShortVideo, onCloseClick)
}

const updateYoutubeShortVideoApi = ({
  youtubeShortVideo,
  youtubeShortVideoId,
  onCloseClick,
}) => {
  return ApiPut(
    `/short/admin/${youtubeShortVideoId}`,
    youtubeShortVideo,
    onCloseClick
  )
}

const deleteYoutubeShortVideoApi = ({ youtubeShortVideoId }) => {
  return del(`/short/admin/${youtubeShortVideoId}`)
}

function* fetchYoutubeShortVideos({ payload }) {

  try {
    const response = yield call(getYoutubeShortVideosAPi, payload)
    yield put(getYoutubeShortVideosSuccess(response))
  } catch (error) {
    yield put(getYoutubeShortVideosFail(error))
  }
}

function* fetchYoutubeShortVideoDetails({ payload: youtubeShortVideoId }) {
  try {
    const response = yield call(
      getYoutubeShortVideoDetailsAPi,
      youtubeShortVideoId
    )
    yield put(getYoutubeShortVideoDetailsSuccess(response))
  } catch (error) {
    yield put(getYoutubeShortVideoDetailsFail(error))
  }
}

function* onCreateYoutubeShortVideo({ payload }) {
  try {
    const response = yield call(createYoutubeShortVideoApi, payload)

    yield put(createYoutubeShortVideoSuccess(response))
    if (payload?.onCloseClick) {
      payload.onCloseClick()
    }
    doneNotification("Youtube Short Video Created Successfully!")
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(createYoutubeShortVideoFail(error))
  }
}

function* onUpdateYoutubeShortVideo({ payload }) {
  try {
    const response = yield call(updateYoutubeShortVideoApi, payload)
    if (response) {
      Notification({
        type: "success",
        message: "Youtube Short Video Updated Successfully!",
        title: "",
      })
      yield put(updateYoutubeShortVideoSuccess(response))
      if (payload?.onCloseClick) {
        payload.onCloseClick()
      }
      if (payload.history) {
        payload.history.push("/youtube-short-video/all")
      }
    }
  } catch (error) {
    if (error.response?.data?.message) {
      Notification({
        type: "error",
        message: error.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(updateYoutubeShortVideoFail(error.response.data))
  }
}

function* onDeleteYoutubeShortVideo({ payload }) {
  try {
    const response = yield call(deleteYoutubeShortVideoApi, payload)
    yield put(deleteYoutubeShortVideoSuccess(response))
    doneNotification("Youtube Short Video Deleted Successfully!")
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    yield put(deleteYoutubeShortVideoFail(error?.response?.data))
  }
}

function* youtubeSaga() {
  yield takeEvery(GET_YOUTUBE_SHORT_VIDEOS, fetchYoutubeShortVideos)
  yield takeEvery(
    GET_YOUTUBE_SHORT_VIDEO_DETAILS,
    fetchYoutubeShortVideoDetails
  )
  yield takeEvery(CREATE_YOUTUBE_SHORT_VIDEO, onCreateYoutubeShortVideo)
  yield takeEvery(UPDATE_YOUTUBE_SHORT_VIDEO, onUpdateYoutubeShortVideo)
  yield takeEvery(DELETE_YOUTUBE_SHORT_VIDEO, onDeleteYoutubeShortVideo)
}

export default youtubeSaga

function doneNotification(message) {
  Notification({
    type: "success",
    message: message,
    title: "",
  })
}
